import React from "react"
import { FaGithub, FaTwitterSquare, FaLinkedinIn } from "react-icons/fa"

export default [
  {
    icon: <FaGithub />,
    url: "https://github.com/Greg919617",
  },
  {
    icon: <FaTwitterSquare />,
    url: "https://twitter.com/Releaseullc",
  },
  {
    icon: <FaLinkedinIn />,
    url: "https://www.linkedin.com/in/greg-jones-47544b88/",
  },
]
